module.exports = __webpack_public_path__ + "static/img/bg.4367c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpg
// module id = A1K6
// module chunks = 9